import React from "react";
import "./Form.css"

// THIS FILE WILL CONTAIN SMALL CONSTANT COMPONENTS TO BE USED THROUGHOUT FORMS IN AMS NEW WORLD

/**
 * Mandatory field star icon
 */
export function MANDATORY_ICON() {
  return <i className="bi bi-asterisk mandatory-field" aria-hidden="true"/>;
}